<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div class="row g-6">
      <div class="col-12 mb-4">
        <div class="card">
          <h4 class="card-header">{{ $t("reports.finance_report") }}</h4>
          <div class="card-body">
            <div class="row">
              <div
                :class="[
                  getFrequencyColumnClass('financial'),
                  'col-md-6',
                  'col-sm-12',
                  'mb-4',
                ]"
              >
                <label class="form-label" for="frequency_financial">{{
                  $t("reports.frequency")
                }}</label>
                <select
                  v-model="reports.financial.frequency"
                  class="form-select"
                  id="frequency_financial"
                >
                  <option value="yearly">{{ $t("reports.yearly") }}</option>
                  <option value="monthly">{{ $t("reports.monthly") }}</option>
                  <option value="daily">{{ $t("reports.daily") }}</option>
                  <option value="fixed">{{ $t("reports.duration") }}</option>
                </select>
              </div>

              <div
                v-if="showYear('financial')"
                :class="[
                  getColumnClass('financial'),
                  'col-md-6',
                  'col-sm-12',
                  'mb-4',
                ]"
              >
                <label class="form-label" for="year_financial">{{
                  $t("reports.year")
                }}</label>
                <select
                  class="form-select"
                  id="year_financial"
                  v-model="reports.financial.selectedYear"
                >
                  <option v-for="year in years" :key="year" :value="year">{{
                    year
                  }}</option>
                </select>
              </div>

              <div
                v-if="showMonth('financial')"
                :class="[
                  getColumnClass('financial'),
                  'col-md-6',
                  'col-sm-12',
                  'mb-4',
                ]"
              >
                <label class="form-label" for="month_financial">{{
                  $t("reports.month")
                }}</label>
                <select
                  class="form-select"
                  id="month_financial"
                  v-model="reports.financial.selectedMonth"
                >
                  <option v-for="month in months" :key="month" :value="month">{{
                    month
                  }}</option>
                </select>
              </div>

              <div
                v-if="showDay('financial')"
                :class="[
                  getColumnClass('financial'),
                  'col-md-6',
                  'col-sm-12',
                  'mb-4',
                ]"
              >
                <label class="form-label" for="day_financial">{{
                  $t("reports.day")
                }}</label>
                <select
                  class="form-select"
                  id="day_financial"
                  v-model="reports.financial.selectedDay"
                >
                  <option
                    v-for="day in Array.from({ length: 31 }, (_, i) =>
                      String(i + 1).padStart(2, '0')
                    )"
                    :key="day"
                    :value="day"
                    >{{ day }}</option
                  >
                </select>
              </div>

              <div
                v-if="reports.financial.frequency === 'fixed'"
                class="col-xl-4 col-md-6 col-sm-12 mb-4"
              >
                <label class="form-label" for="from_financial">{{
                  $t("reports.from")
                }}</label>
                <input
                  type="date"
                  class="form-control"
                  id="from_financial"
                  v-model="reports.financial.fixedFrom"
                />
              </div>

              <div
                v-if="reports.financial.frequency === 'fixed'"
                class="col-xl-4 col-md-6 col-sm-12 mb-4"
              >
                <label class="form-label" for="to_financial">{{
                  $t("reports.to")
                }}</label>
                <input
                  type="date"
                  class="form-control"
                  id="to_financial"
                  v-model="reports.financial.fixedTo"
                />
              </div>

              <div class="col-12 mb-4 mt-4">
                <button
                  class="btn btn-primary w-100"
                  @click="generate('financial')"
                >
                  {{ $t("reports.generate") }}
                </button>
              </div>

              <div
                class="col-12"
                v-if="reports.financial.showReport"
                id="finance_report_financial"
              >
                <div class="row">
                  <div class="col-12 rounded p-12 mt-4 report-bg">
                    <div class="row text-center mb-4 align-items-center">
                      <div class="col text-start">
                        <div class="app-brand-link">
                          <div class="" style="width: 3.2rem">
                            <img src="@/assets/img/logo-icon.svg" alt />
                          </div>
                          <span
                            class="app-brand-text demo menu-text fw-bold"
                            style="width: 8.5rem"
                          >
                            <img src="@/assets/img/logo-text.svg" alt />
                          </span>
                        </div>
                      </div>

                      <div class="col flex flex-col items-center">
                        <div class="text-primary">
                          {{ settings.network_name }}
                        </div>
                        <div>{{ user.email }}</div>
                      </div>

                      <div class="col text-end">
                        <div class="text-primary">
                          <strong>{{
                            getReportPeriodLabel("financial")
                          }}</strong>
                        </div>
                        <div>{{ getReportPeriodValue("financial") }}</div>
                      </div>
                    </div>

                    <div class="card report-card mt-7">
                      <h5 class="card-header text-center">
                        {{ $t("reports.finance_report") }}
                      </h5>
                      <div class="table-responsive text-nowrap">
                        <table class="table">
                          <thead>
                            <tr class="table-primary">
                              <td>{{ getDateLabel("financial") }}</td>
                              <td>{{ $t("reports.amount") }}</td>
                            </tr>
                          </thead>
                          <tbody class="table-border-bottom-0">
                            <tr
                              v-for="(item, index) in reports.financial
                                .reportData"
                              :key="index"
                            >
                              <td>{{ item.time }}</td>
                              <td>{{ item.amount }}</td>
                            </tr>
                            <tr class="table-primary">
                              <td>{{ $t("reports.total") }}</td>
                              <td>
                                {{
                                  getTotalAmount("financial") +
                                    settings.currency
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mt-9 noPrint">
                    <button
                      class="btn btn-info w-100"
                      @click="printReport('financial')"
                    >
                      <span class="ti-xs ti ti-printer me-2"></span
                      >{{ $t("actions.print") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-4">
        <div class="card">
          <h4 class="card-header">{{ $t("reports.sells") }}</h4>
          <div class="card-body">
            <div class="row">
              <div
                :class="[
                  getFrequencyColumnClass('sells'),
                  'col-md-6',
                  'col-sm-12',
                  'mb-4',
                ]"
              >
                <label class="form-label" for="frequency_sells">{{
                  $t("reports.frequency")
                }}</label>
                <select
                  v-model="reports.sells.frequency"
                  class="form-select"
                  id="frequency_sells"
                >
                  <option value="yearly">{{ $t("reports.yearly") }}</option>
                  <option value="monthly">{{ $t("reports.monthly") }}</option>
                  <option value="daily">{{ $t("reports.daily") }}</option>
                  <option value="fixed">{{ $t("reports.duration") }}</option>
                </select>
              </div>

              <div
                v-if="showYear('sells')"
                :class="[
                  getColumnClass('sells'),
                  'col-md-6',
                  'col-sm-12',
                  'mb-4',
                ]"
              >
                <label class="form-label" for="year_sells">{{
                  $t("reports.year")
                }}</label>
                <select
                  class="form-select"
                  id="year_sells"
                  v-model="reports.sells.selectedYear"
                >
                  <option v-for="year in years" :key="year" :value="year">{{
                    year
                  }}</option>
                </select>
              </div>

              <div
                v-if="showMonth('sells')"
                :class="[
                  getColumnClass('sells'),
                  'col-md-6',
                  'col-sm-12',
                  'mb-4',
                ]"
              >
                <label class="form-label" for="month_sells">{{
                  $t("reports.month")
                }}</label>
                <select
                  class="form-select"
                  id="month_sells"
                  v-model="reports.sells.selectedMonth"
                >
                  <option v-for="month in months" :key="month" :value="month">{{
                    month
                  }}</option>
                </select>
              </div>

              <div
                v-if="showDay('sells')"
                :class="[
                  getColumnClass('sells'),
                  'col-md-6',
                  'col-sm-12',
                  'mb-4',
                ]"
              >
                <label class="form-label" for="day_sells">{{
                  $t("reports.day")
                }}</label>
                <select
                  class="form-select"
                  id="day_sells"
                  v-model="reports.sells.selectedDay"
                >
                  <option
                    v-for="day in Array.from({ length: 31 }, (_, i) =>
                      String(i + 1).padStart(2, '0')
                    )"
                    :key="day"
                    :value="day"
                    >{{ day }}</option
                  >
                </select>
              </div>

              <div
                v-if="reports.sells.frequency === 'fixed'"
                class="col-xl-4 col-md-6 col-sm-12 mb-4"
              >
                <label class="form-label" for="from_sells">{{
                  $t("reports.from")
                }}</label>
                <input
                  type="date"
                  class="form-control"
                  id="from_sells"
                  v-model="reports.sells.fixedFrom"
                />
              </div>

              <div
                v-if="reports.sells.frequency === 'fixed'"
                class="col-xl-4 col-md-6 col-sm-12 mb-4"
              >
                <label class="form-label" for="to_sells">{{
                  $t("reports.to")
                }}</label>
                <input
                  type="date"
                  class="form-control"
                  id="to_sells"
                  v-model="reports.sells.fixedTo"
                />
              </div>

              <div class="col-12 mb-4 mt-4">
                <button
                  class="btn btn-primary w-100"
                  @click="generate('sells')"
                >
                  {{ $t("reports.generate") }}
                </button>
              </div>

              <div
                class="col-12"
                v-if="reports.sells.showReport"
                id="finance_report_sells"
              >
                <div class="row">
                  <div class="col-12 rounded p-12 mt-4 report-bg">
                    <div class="row text-center mb-4 align-items-center">
                      <div class="col text-start">
                        <div class="app-brand-link">
                          <div class="" style="width: 3.2rem">
                            <img src="@/assets/img/logo-icon.svg" alt />
                          </div>
                          <span
                            class="app-brand-text demo menu-text fw-bold"
                            style="width: 8.5rem"
                          >
                            <img src="@/assets/img/logo-text.svg" alt />
                          </span>
                        </div>
                      </div>

                      <div class="col flex flex-col items-center">
                        <div class="text-primary">
                          {{ settings.network_name }}
                        </div>
                        <div>{{ user.email }}</div>
                      </div>

                      <div class="col text-end">
                        <div class="text-primary">
                          <strong>{{ getReportPeriodLabel("sells") }}</strong>
                        </div>
                        <div>{{ getReportPeriodValue("sells") }}</div>
                      </div>
                    </div>

                    <div class="card report-card mt-7">
                      <h5 class="card-header text-center">
                        {{ $t("reports.accounts") }}
                      </h5>
                      <div class="table-responsive text-nowrap">
                        <table class="table">
                          <thead>
                            <tr class="table-primary">
                              <td>{{ getDateLabel("sells") }}</td>
                              <td>{{ $t("reports.profile") }}</td>
                              <td>{{ $t("reports.accounts_count") }}</td>
                            </tr>
                          </thead>
                          <tbody class="table-border-bottom-0">
                            <tr
                              v-for="(item, index) in reports.sells.reportData
                                .accounts"
                              :key="index"
                            >
                              <td>{{ item.time }}</td>
                              <td>{{ item.profile }}</td>
                              <td>{{ item.count }}</td>
                            </tr>
                            <tr class="table-primary">
                              <td>{{ $t("reports.total") }}</td>
                              <td></td>
                              <td>
                                {{ getTotalAmount("sells_accounts") }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="card report-card mt-7">
                      <h5 class="card-header text-center">
                        {{ $t("reports.cards") }}
                      </h5>
                      <div class="table-responsive text-nowrap">
                        <table class="table">
                          <thead>
                            <tr class="table-primary">
                              <td>{{ getDateLabel("sells") }}</td>
                              <td>{{ $t("reports.batch") }}</td>
                              <td>{{ $t("reports.cards_count") }}</td>
                            </tr>
                          </thead>
                          <tbody class="table-border-bottom-0">
                            <tr
                              v-for="(item, index) in reports.sells.reportData
                                .cards"
                              :key="index"
                            >
                              <td>{{ item.time }}</td>
                              <td>{{ item.batch_name }}</td>
                              <td>{{ item.count }}</td>
                            </tr>
                            <tr class="table-primary">
                              <td>{{ $t("reports.total") }}</td>
                              <td></td>
                              <td>
                                {{ getTotalAmount("sells_cards") }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mt-9 noPrint">
                    <button
                      class="btn btn-info w-100"
                      @click="printReport('sells')"
                    >
                      <span class="ti-xs ti ti-printer me-2"></span
                      >{{ $t("actions.print") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-4">
        <div class="card">
          <h4 class="card-header">{{ $t("reports.reseller") }}</h4>
          <div class="card-body">
            <div class="row">
              <div
                :class="[
                  getFrequencyColumnClass('reseller'),
                  'col-md-6',
                  'col-sm-12',
                  'mb-4',
                ]"
              >
                <label class="form-label" for="id_reseller">{{
                  $t("admins.reseller")
                }}</label>
                <select
                  v-model="reports.reseller.selectedReseller"
                  class="form-select"
                  id="id_reseller"
                >
                  <option value="-1">{{ $t("control.all") }}</option>
                  <option
                    v-for="(reseller, index) in resellers"
                    :key="reseller.id"
                    :value="reseller.id"
                    >{{ reseller.email }}</option
                  >
                </select>
              </div>

              <div
                :class="[
                  getFrequencyColumnClass('reseller'),
                  'col-md-6',
                  'col-sm-12',
                  'mb-4',
                ]"
              >
                <label class="form-label" for="frequency_reseller">{{
                  $t("reports.frequency")
                }}</label>
                <select
                  v-model="reports.reseller.frequency"
                  class="form-select"
                  id="frequency_reseller"
                >
                  <option value="yearly">{{ $t("reports.yearly") }}</option>
                  <option value="monthly">{{ $t("reports.monthly") }}</option>
                  <option value="daily">{{ $t("reports.daily") }}</option>
                  <option value="fixed">{{ $t("reports.duration") }}</option>
                </select>
              </div>

              <div
                v-if="showYear('reseller')"
                :class="[
                  getColumnClass('reseller'),
                  'col-md-6',
                  'col-sm-12',
                  'mb-4',
                ]"
              >
                <label class="form-label" for="year_reseller">{{
                  $t("reports.year")
                }}</label>
                <select
                  class="form-select"
                  id="year_reseller"
                  v-model="reports.reseller.selectedYear"
                >
                  <option v-for="year in years" :key="year" :value="year">{{
                    year
                  }}</option>
                </select>
              </div>

              <div
                v-if="showMonth('reseller')"
                :class="[
                  getColumnClass('reseller'),
                  'col-md-6',
                  'col-sm-12',
                  'mb-4',
                ]"
              >
                <label class="form-label" for="month_reseller">{{
                  $t("reports.month")
                }}</label>
                <select
                  class="form-select"
                  id="month_reseller"
                  v-model="reports.reseller.selectedMonth"
                >
                  <option v-for="month in months" :key="month" :value="month">{{
                    month
                  }}</option>
                </select>
              </div>

              <div
                v-if="showDay('reseller')"
                :class="[
                  getColumnClass('reseller'),
                  'col-md-6',
                  'col-sm-12',
                  'mb-4',
                ]"
              >
                <label class="form-label" for="day_reseller">{{
                  $t("reports.day")
                }}</label>
                <select
                  class="form-select"
                  id="day_reseller"
                  v-model="reports.reseller.selectedDay"
                >
                  <option
                    v-for="day in Array.from({ length: 31 }, (_, i) =>
                      String(i + 1).padStart(2, '0')
                    )"
                    :key="day"
                    :value="day"
                    >{{ day }}</option
                  >
                </select>
              </div>

              <div
                v-if="reports.reseller.frequency === 'fixed'"
                class="col-xl-4 col-md-6 col-sm-12 mb-4"
              >
                <label class="form-label" for="from_reseller">{{
                  $t("reports.from")
                }}</label>
                <input
                  type="date"
                  class="form-control"
                  id="from_reseller"
                  v-model="reports.reseller.fixedFrom"
                />
              </div>

              <div
                v-if="reports.reseller.frequency === 'fixed'"
                class="col-xl-4 col-md-6 col-sm-12 mb-4"
              >
                <label class="form-label" for="to_reseller">{{
                  $t("reports.to")
                }}</label>
                <input
                  type="date"
                  class="form-control"
                  id="to_reseller"
                  v-model="reports.reseller.fixedTo"
                />
              </div>

              <div class="col-12 mb-4 mt-4">
                <button
                  class="btn btn-primary w-100"
                  @click="generate('reseller')"
                >
                  {{ $t("reports.generate") }}
                </button>
              </div>

              <div
                class="col-12"
                v-if="reports.reseller.showReport"
                id="finance_report_reseller"
              >
                <div
                  v-for="(rese, index) in reports.reseller.reportData"
                  :key="index"
                  class="row"
                >
                  <div class="col-12 rounded p-12 mt-4 report-bg">
                    <div class="row text-center mb-4 align-items-center">
                      <div class="col text-start">
                        <div class="app-brand-link">
                          <div class="" style="width: 3.2rem">
                            <img src="@/assets/img/logo-icon.svg" alt />
                          </div>
                          <span
                            class="app-brand-text demo menu-text fw-bold"
                            style="width: 8.5rem"
                          >
                            <img src="@/assets/img/logo-text.svg" alt />
                          </span>
                        </div>
                      </div>

                      <div class="col flex flex-col items-center">
                        <div class="text-primary">
                          {{ settings.network_name }}
                        </div>
                        <div>{{ rese.user.email }}</div>
                      </div>

                      <div class="col text-end">
                        <div class="text-primary">
                          <strong>{{
                            getReportPeriodLabel("reseller")
                          }}</strong>
                        </div>
                        <div>{{ getReportPeriodValue("reseller") }}</div>
                      </div>
                    </div>

                    <div class="card report-card mt-7">
                      <h5 class="card-header text-center">
                        {{ $t("reports.reseller") }}
                      </h5>
                      <div class="table-responsive text-nowrap">
                        <table class="table">
                          <thead>
                            <tr class="table-primary">
                              <td>{{ getDateLabel("reseller") }}</td>
                              <td>{{ $t("reports.bills_count") }}</td>
                              <td>{{ $t("reports.amount") }}</td>
                            </tr>
                          </thead>
                          <tbody class="table-border-bottom-0">
                            <tr
                              v-for="(item, index) in rese.bills"
                              :key="index"
                            >
                              <td>{{ item.time }}</td>
                              <td>{{ item.count }}</td>
                              <td>{{ item.price }}</td>
                            </tr>
                            <tr class="table-primary">
                              <td>{{ $t("reports.total") }}</td>
                              <td>
                                {{ getTotalAmount("reseller_count", rese) }}
                              </td>
                              <td>
                                {{
                                  getTotalAmount("reseller_price", rese) +
                                    settings.currency
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mt-9 noPrint">
                    <button
                      class="btn btn-info w-100"
                      @click="printReport('reseller')"
                    >
                      <span class="ti-xs ti ti-printer me-2"></span
                      >{{ $t("actions.print") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { print_element } from "../global_constants";
export default {
  name: "FinancialReports",
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  data() {
    return {
      username: "ahmad@ssradius",
      years: this.generateYears(2000, 2030),
      currentDate: new Date().toISOString().split("T")[0],
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      reports: {
        financial: {
          frequency: "yearly",
          selectedYear: new Date().getFullYear(),
          selectedMonth: "01",
          selectedDay: "01",
          fixedFrom: "",
          fixedTo: "",
          showReport: false,
          reportData: [
            { date: "05-10-2024", amount: "785142$" },
            { date: "05-10-2024", amount: "785142$" },
          ],
        },
        sells: {
          frequency: "yearly",
          selectedYear: new Date().getFullYear(),
          selectedMonth: "01",
          selectedDay: "01",
          fixedFrom: "",
          fixedTo: "",
          showReport: false,
          reportData: [
            { date: "06-10-2024", amount: "456789$" },
            { date: "07-10-2024", amount: "123456$" },
          ],
        },
        reseller: {
          frequency: "yearly",
          selectedYear: new Date().getFullYear(),
          selectedMonth: "01",
          selectedDay: "01",
          fixedFrom: "",
          fixedTo: "",
          showReport: false,
          selectedReseller: -1,
          reportData: [
            { date: "08-10-2024", amount: "987654$" },
            { date: "09-10-2024", amount: "345678$" },
            { date: "10-10-2024", amount: "234567$" },
          ],
        },
      },
      resellers: [],
    };
  },
  methods: {
    generateYears(start, end) {
      const list = [];
      for (let y = start; y <= end; y++) list.push(y);
      return list;
    },
    async generate(reportType) {
      switch (reportType) {
        case "financial":
          const response1 = await axios.get(
            `reports/finance?type=${this.reports.financial.frequency}&year=${this.reports.financial.selectedYear}&month=${this.reports.financial.selectedMonth}&day=${this.reports.financial.selectedDay}&report_date_start=${this.reports.financial.fixedFrom}&report_date_end=${this.reports.financial.fixedTo}`
          );
          if (response1.status == 200) {
            this.reports.financial.reportData = response1.data.data;
          }
          break;
        case "sells":
          const response2 = await axios.get(
            `reports/sells?type=${this.reports.sells.frequency}&year=${this.reports.sells.selectedYear}&month=${this.reports.sells.selectedMonth}&day=${this.reports.sells.selectedDay}&report_date_start=${this.reports.sells.fixedFrom}&report_date_end=${this.reports.sells.fixedTo}`
          );
          if (response2.status == 200) {
            this.reports.sells.reportData = response2.data.data;
          }
          break;
        case "reseller":
          const response3 = await axios.get(
            `reports/reseller?type=${this.reports.reseller.frequency}&year=${this.reports.reseller.selectedYear}&month=${this.reports.reseller.selectedMonth}&day=${this.reports.reseller.selectedDay}&report_date_start=${this.reports.reseller.fixedFrom}&report_date_end=${this.reports.reseller.fixedTo}&user_id=${this.reports.reseller.selectedReseller}`
          );
          if (response3.status == 200) {
            this.reports.reseller.reportData = response3.data.data;
          }
          break;

        default:
          break;
      }
      this.reports[reportType].showReport = true;
      console.log(`Generating ${reportType} report with:`, {
        frequency: this.reports[reportType].frequency,
        year: this.reports[reportType].selectedYear,
        month: this.reports[reportType].selectedMonth,
        day: this.reports[reportType].selectedDay,
        from: this.reports[reportType].fixedFrom,
        to: this.reports[reportType].fixedTo,
      });
    },
    printReport(reportType) {
      console.log(`Printing ${reportType} report`);

      const reportElement = document.getElementById(
        `finance_report_${reportType}`
      );
      print_element(`finance_report_${reportType}`);
      // if (reportElement) {
      //   const printWindow = window.open("", "_blank");
      //   printWindow.document.write("<html><head><title>Print Report</title>");
      //   printWindow.document.write(
      //     '<link rel="stylesheet" href="' +
      //       window.location.origin +
      //       '/css/style.css">'
      //   );
      //   printWindow.document.write("</head><body>");
      //   printWindow.document.write(reportElement.innerHTML);
      //   printWindow.document.write("</body></html>");
      //   printWindow.document.close();
      //   printWindow.focus();
      //   printWindow.print();
      //   printWindow.close();
      // } else {
      //   window.print();
      // }
    },
    getFrequencyColumnClass(reportType) {
      const frequency = this.reports[reportType].frequency;
      if (frequency === "daily") return "col-xl-3";
      if (frequency === "monthly") return "col-xl-4";
      if (frequency === "yearly") return "col-xl-6";
      if (frequency === "fixed") return "col-xl-4";
      return "col-xl-4";
    },
    getColumnClass(reportType) {
      const frequency = this.reports[reportType].frequency;
      if (frequency === "daily") return "col-xl-3";
      if (frequency === "monthly") return "col-xl-4";
      if (frequency === "yearly") return "col-xl-6";
      return "col-xl-4";
    },
    showYear(reportType) {
      return ["yearly", "monthly", "daily"].includes(
        this.reports[reportType].frequency
      );
    },
    showMonth(reportType) {
      return ["monthly", "daily"].includes(this.reports[reportType].frequency);
    },
    showDay(reportType) {
      return this.reports[reportType].frequency === "daily";
    },
    getDateLabel(reportType) {
      switch (this.reports[reportType].frequency) {
        case "yearly":
          return this.$t("reports.month");
        case "monthly":
          return this.$t("reports.day");
        case "daily":
          return this.$t("reports.hour");
        case "fixed":
          return this.$t("reports.day");
        default:
          return this.$t("reports.day");
      }
    },
    getReportPeriodLabel(reportType) {
      switch (this.reports[reportType].frequency) {
        case "yearly":
          return this.$t("reports.yearly");
        case "monthly":
          return this.$t("reports.monthly");
        case "daily":
          return this.$t("reports.daily");
        case "fixed":
          return this.$t("reports.duration");
        default:
          return this.$t("reports.year");
      }
    },
    getReportPeriodValue(reportType) {
      const report = this.reports[reportType];
      switch (report.frequency) {
        case "yearly":
          return report.selectedYear;
        case "monthly":
          return `${report.selectedYear}-${String(
            report.selectedMonth
          ).padStart(2, "0")}`;
        case "daily":
          return `${report.selectedYear}-${String(
            report.selectedMonth
          ).padStart(2, "0")}-${String(report.selectedDay).padStart(2, "0")}`;
        case "fixed":
          return `${report.fixedFrom} to ${report.fixedTo}`;
        default:
          return "1992-01";
      }
    },
    getTotalAmount(reportType, reseller = null) {
      if (reportType == "reseller_count") {
        return reseller.bills.reduce((total, item) => {
          return total + +item.count;
        }, 0);
      }
      if (reportType == "reseller_price") {
        return reseller.bills.reduce((total, item) => {
          return total + +item.price;
        }, 0);
      }
      if (reportType == "sells_accounts") {
        return this.reports.sells.reportData.accounts.reduce((total, item) => {
          return total + +item.count;
        }, 0);
      }
      if (reportType == "sells_cards") {
        return this.reports.sells.reportData.cards.reduce((total, item) => {
          return total + +item.count;
        }, 0);
      }
      return this.reports[reportType].reportData.reduce((total, item) => {
        // const amount = parseFloat(item.amount.replace(/[^0-9]/g, "")).toFixed(
        //   2
        // );
        return total + +item.amount;
      }, 0);
    },
    async fetchResellers() {
      const response = await axios.get(
        "admins?filter=1&type=resellers&rows=10000&itr=true"
      );
      if (response.status == 200) this.resellers = response.data.data;
    },
    print_element(id) {
      print_element(id);
    },
  },
  async created() {
    await this.fetchResellers();
  },
  mounted() {
    const today = new Date().toISOString().split("T")[0];
    Object.keys(this.reports).forEach((reportType) => {
      this.reports[reportType].fixedFrom = today;
      this.reports[reportType].fixedTo = today;
    });
  },
};
</script>
<style scoped>
@media screen {
  .noPrint {
  }
  .noScreen {
    display: none;
  }
  .scroll {
    height: 30rem;
  }
}

@media print {
  .noPrint {
    display: none;
  }
  .noScreen {
  }
  .scroll {
  }
}
</style>
